<div [formGroup]="this.formGroup">
    <mat-form-field class="field-input" appearance="outline" style="width: 100%;">
        <mat-label>{{field.label}}</mat-label>
        <input [type]="showPassword ? 'text' : 'password'" matInput placeholder="{{field.label}}" [formControlName]="this.fieldKey">
        <button
            type="button"
            matSuffix
            class="show-hide-pw-btn"
            (click)="togglePasswordVisibility()"
        >
            <mat-icon class="show-hide-pw-icon">
                {{ showPassword ? 'visibility_off' : 'visibility' }}
            </mat-icon>
        </button>
    </mat-form-field>
</div>